module.exports = __webpack_public_path__ + "static/media/file_type_image_icon.7e029920.svg";